$(document).ready(function() {
// home page slider  
$('.slider_product_show').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
    navText:['<svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none"><path d="M6.00488 10L1.00488 5.25L6.00488 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none"><path d="M1.00513 10L6.00513 5.25L1.00513 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
    dots:false,
    responsive:{
        0:{
            items:2,
            margin:10,
        },
        600:{
            items:3,
            margin:15,
        },
        1000:{
            items:4,
            margin:10
        },
        1200:{
            items:4
        }
    }
});
 
setTimeout(function() { 
  // product page related products slider
$('.related_products_slider').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
    navText:['<svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none"><path d="M6.00488 10L1.00488 5.25L6.00488 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none"><path d="M1.00513 10L6.00513 5.25L1.00513 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
    dots:false,
    responsive:{
        0:{
            items:2,
            margin:10,
        },
        600:{
            items:3,
            margin:15,
        },
        1000:{
            items:4,
            margin:10
        },
        1200:{
            items:4
        }
    }
});
}, 1500);
  
if($(window).width() < 750) {
  $('.instagram_slider_custom').slick({
      dots: true,
      infinite: true,
      slidesToShow: 2,
      prevArrow: false,
      nextArrow: false,
   });
}
if($(window).width() < 989) {  
$('.footer_icon_slider').owlCarousel({
    loop:true,
    margin:0,
    nav:true,
    navText:['<svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M6.49997 11L1.23682 6L6.49997 1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M0.500026 11L5.76318 6L0.500026 1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
    dots:false,
    responsive:{
        0:{
            items:1
          
        },
        600:{
            items:3,
            margin:15,
        },
        1000:{
            items:4,
            margin:10
        },
        1200:{
            items:1
        }
    }
});
  
}

// collection page search Category 
$('.itg_custom_search input#itg_search_Category').on('keyup', function() {
    var filter = $(this).val();
    count = 0;
    $('ul.Search_Category li a').each(function() {
      if ($(this).attr("data-attr").search(new RegExp(filter, "i")) < 0) {
        $(this).hide();  
      } else {
        $(this).show(); 
        count++;
      }
    });
   });

// product page description tab js
  $(document).on("click", ".itg_set > a",function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".custom_content").slideUp(200);
      $(".itg_set > a i").removeClass("fa-minus").addClass("fa-plus");
    } 
    else {
      $(".itg_set > a i").removeClass("fa-minus").addClass("fa-plus");
      $(this)
       .find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".itg_set > a").removeClass("active");
      $(this).addClass("active");
       $(".custom_content").slideUp(200);
      $(this)
        .siblings(".custom_content").slideDown(200);
    }
  });  
 
			
       

});